"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
function FormFields(_a) {
    var agreementUrl = _a.agreementUrl, values = _a.values, onChange = _a.onChange;
    return (react_1.default.createElement("ul", null,
        react_1.default.createElement("li", null,
            react_1.default.createElement("label", null, "Anrede"),
            react_1.default.createElement("select", { name: "anrede", value: values.anrede, required: true, onChange: onChange },
                react_1.default.createElement("option", { disabled: true, value: "" }, "Anrede w\u00E4hlen..."),
                react_1.default.createElement("option", { value: "Herr" }, "Herr"),
                react_1.default.createElement("option", { value: "Frau" }, "Frau"))),
        react_1.default.createElement("li", null,
            react_1.default.createElement("label", null, "Vorname"),
            react_1.default.createElement("input", { type: "text", name: "vorname", placeholder: " ", onChange: onChange, value: values.vorname, required: true })),
        react_1.default.createElement("li", null,
            react_1.default.createElement("label", null, "Nachname"),
            react_1.default.createElement("input", { type: "text", name: "nachname", placeholder: " ", onChange: onChange, value: values.nachname, required: true })),
        react_1.default.createElement("li", null,
            react_1.default.createElement("label", null, "E-Mail-Adresse"),
            react_1.default.createElement("input", { type: "email", name: "email", placeholder: " ", onChange: onChange, value: values.email, required: true })),
        react_1.default.createElement("li", null,
            react_1.default.createElement("label", null,
                react_1.default.createElement("input", { type: "checkbox", name: "agreed", placeholder: " ", onChange: onChange, required: true }),
                react_1.default.createElement("a", { href: agreementUrl, target: "_blank", rel: "noopener noreferrer" }, "Nutzungsbedingungen"),
                "zustimmen"))));
}
exports.FormFields = FormFields;
